import { useMutation } from "react-query";
import http from "infra/http";
import { AnexoResponse } from 'core/features/arquivo/typings/index';

function useUploadImagemParceiro(id: string) {
  return useMutation(
    `/v1/parceiro/${id}/imagens`,
    async (file: File) =>
    {
      const form = new FormData();
      
      form.append('file', file);

      return await http.post<AnexoResponse>(
        `/v1/parceiro/${id}/imagens`, form
      )},
    { retry: false }
  );
}

export default useUploadImagemParceiro;
